<template>
  <div>
    <b-card class="shadow rounded mb-3 pb-4">
      <div class="text-right px-3"></div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="10000"
        filename="report"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        ref="html2Pdf"
        pdf-content-width="100%"
        @hasStartedGeneration="hasStartedGeneration"
        @progress="onProgress($event)"
        @hasGenerated="hasGenerated($event)"
      >
        <section slot="pdf-content" class="pt-4">
          <b-container>
            <b-row
              class="pb-3"
              style="border-bottom: 1px solid #e1e5eb !important"
            >
              <b-col>
                <h6 class="lead text-muted">
                  {{ selectedButton }}
                  <small
                    >{{ proposals.length }}
                    <i class="fas fa-caret-down text-danger"></i
                  ></small>
                </h6>
                <h2 class="card-subtitle">
                  {{ totalAmount | currency
                  }}<i class="fas fa-caret-up text-success"></i>
                </h2>
              </b-col>
              <b-col class="d-flex flex-column">
                <div>
                  <b-button-group class="float-right" size="sm">
                    <b-button
                      v-for="(filter, index) in filterArr"
                      :key="index"
                      variant="outline-primary"
                      :pressed="selectedButton === filter"
                      >{{ filter }}</b-button
                    >
                  </b-button-group>
                </div>
                <div class="d-flex justify-content-end mt-2">
                  <VueCtkDateTimePicker
                    id="dataPicker"
                    v-model="filterPeriod"
                    auto-close
                    only-date
                    range
                    locale="pt"
                  />
                </div>
              </b-col>
            </b-row>

            <Chart :series="chartData" :period="filterPeriod" />
            <div class="d-flex justify-content-between mt-5">
              <b-card
                v-for="(info, index) in setAmountInformation"
                :key="index"
                class="shadow rounded mx-3 w-50"
              >
                <div class="d-flex flex-column text-muted">
                  <span
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h6 class="lead">
                      {{ info.modality }}
                      <small class="exp">{{ info.totalProposals }}</small>
                    </h6>
                    <i
                      class="fas fa-arrow-up text-success"
                      style="transform: rotate(45deg)"
                    ></i>
                  </span>
                  <p class="mb-1">
                    <small
                      class="d-flex align-items-center justify-content-between"
                    >
                      {{ info.amount | currency }}
                      <i
                        class="fas fa-arrow-up text-success"
                        style="transform: rotate(45deg)"
                      ></i>
                    </small>
                  </p>
                  <p class="mb-1">
                    <small
                      class="d-flex align-items-center justify-content-between"
                    >
                      {{ (info.amount / info.totalProposals) | currency }}
                      <i
                        class="fas fa-arrow-down text-danger"
                        style="transform: rotate(45deg)"
                      ></i>
                    </small>
                  </p>
                </div>
              </b-card>
            </div>
            <div class="html2pdf__page-break" />
            <b-card
              v-for="(data, index) in proposalsByBranch"
              :key="index"
              class="mb-4"
            >
              <b-card-sub-title class="mb-3">{{
                data.branch
              }}</b-card-sub-title>
              <branchProposalsTable
                :proposals="data.proposals"
                :selectedButton="selectedButton"
              />
              <div class="html2pdf__page-break" />
            </b-card>
          </b-container>
        </section>
      </vue-html2pdf>
      <div>
        <b-row class="pb-3" style="border-bottom: 1px solid #e1e5eb !important">
          <b-col>
            <h6 class="lead text-muted">
              {{ selectedButton }}
              <small
                >{{ proposals.length }}
                <i class="fas fa-caret-down text-danger"></i
              ></small>
            </h6>
            <h2 class="card-subtitle">
              {{ totalAmount | currency
              }}<i class="fas fa-caret-up text-success"></i>
            </h2>
          </b-col>
          <!-- <b-col>
            <div
              v-if="selectedButton === 'Fluxo'"
              class="badge  badge-pill badge-secondary p-2"
              @mouseenter="showDetails = true"
              @mouseleave="showDetails = false"
            >
              Show more details
            </div>
            <div
              v-if="showDetails"
              class="b-card shadow rounded details-wrapper row"
            >
              <b-col
                class="my-2"
                cols="6"
                v-for="(data, index) in detailsData"
                :key="index"
              >
                <div>
                  {{ data.name }}
                </div>
                <div>proposals: {{ data.proposals }}</div>
                <div>values: {{ data.values | currency }}</div>
              </b-col>
            </div>
          </b-col> -->
          <b-col class="d-flex flex-column">
            <div>
              <b-button-group class="float-right" size="sm">
                <b-button
                  v-for="(filter, index) in filterArr"
                  :key="index"
                  @click="selectedButton = filter"
                  :pressed="selectedButton === filter"
                  variant="outline-primary"
                  >{{ filter }}</b-button
                >
              </b-button-group>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <VueCtkDateTimePicker
                id="dataPicker"
                v-model="filterPeriod"
                auto-close
                only-date
                range
                locale="pt"
              />
              <i
                v-if="!isLoading"
                class="fas fa-file-invoice-dollar"
                v-b-tooltip.hover.left
                :title="'Gerar relatório'"
                @click="generateReport"
              ></i>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding: 5px 0"
            ><Chart :series="chartData" :period="filterPeriod"
          /></b-col>
          <b-col>
            <div class="d-flex justify-content-between mini-cards">
              <div
                v-if="details1.length"
                class="d-flex justify-content-between mt-2"
              >
                <b-card
                  v-for="(data, index) in details1"
                  :key="index"
                  class="shadow rounded mx-3"
                  style="width: 300px"
                >
                  <div class="d-flex flex-column text-muted">
                    <span
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div>
                        <div class="card-name">
                          {{ data.name }}
                        </div>
                        <div v-if="data.name !== 'CONVERSION RATE'">
                          <span class="card-proposal mr-1">{{
                            data.proposals
                          }}</span>
                          <small>Propostas</small>
                        </div>
                      </div>
                      <!-- <i
                  class="fas fa-arrow-up text-success"
                  style="transform: rotate(45deg);"
                ></i> -->
                      <vue-ellipse-progress
                        :progress="parseFloat(data.percentage)"
                        color="#247cab"
                        :size="100"
                        :thickness="5"
                        :empty-thickness="5"
                        animation="bounce 700 1000"
                        fontSize="1rem"
                        fontColor="#377dff"
                        dot="12 #185575"
                        empty-color="#c7c7c7"
                      >
                        <span slot="legend-value" class="text-primary">
                          %
                        </span>
                        <span class="small" slot="legend-caption"
                        >do total</span>
                      </vue-ellipse-progress>
                    </span>
                    <small
                      class="
                        card-currency
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      {{ data.values | currency }}
                      <!-- <i
                  class="fas fa-arrow-up text-success"
                  style="transform: rotate(45deg);"
                ></i> -->
                    </small>
                    <!--<div class="d-flex justify-content-center mt-3">
              </div>-->
                    <div class="chart-text">
                      {{ data.text }}
                    </div>
                  </div>
                </b-card>
              </div>
              <!-- <div
                v-if="details2.length"
                class="d-flex justify-content-between mt-2"
              >
                <b-card
                  v-for="(data, index) in details2"
                  :key="index"
                  class="shadow rounded mx-3 w-50"
                  style="min-width: 35%"
                >
                  <div class="d-flex flex-column text-muted">
                    <span
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div>
                        <div class="card-name">
                          {{ data.name }}
                        </div>
                        <div v-if="data.name !== 'CONVERSION RATE'">
                          <span class="card-proposal mr-1">{{
                            data.proposals
                          }}</span>
                          <small>Propostas</small>
                        </div>
                      </div>
                      <vue-ellipse-progress
                        :progress="data.percentage"
                        color="#247cab"
                        :size="100"
                        :thickness="5"
                        :empty-thickness="5"
                        animation="bounce 700 1000"
                        fontSize="1rem"
                        fontColor="#377dff"
                        dot="12 #185575"
                        empty-color="#c7c7c7"
                      >
                        <span slot="legend-value" class="text-primary">
                          %
                        </span>
                        <template v-slot:legend-caption>
                          <span class="small" slot="legend-caption"
                            >do total</span
                          >
                        </template>
                      </vue-ellipse-progress>
                    </span>
                    <div
                      class="
                        card-currency
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      {{ data.values | currency }}
                    </div>
                    <div class="chart-text">
                      {{ data.text }}
                    </div>
                  </div>
                </b-card>
              </div> -->
            </div>
            <div class="d-flex justify-content-between mini-cards">
              <b-card
                v-for="(info, infoIndex) in setAmountInformation"
                :key="infoIndex"
                class="shadow rounded mx-3 w-50"
                style="min-width: 35%"
              >
                <div class="d-flex flex-column text-muted">
                  <span
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h6 class="lead">
                      {{ info.modality }}
                      <small class="exp">{{ info.totalProposals }}</small>
                    </h6>
                    <i
                      class="fas fa-arrow-up text-success"
                      style="transform: rotate(45deg)"
                    ></i>
                  </span>
                  <p class="mb-1">
                    <small
                      class="d-flex align-items-center justify-content-between"
                    >
                      {{ info.amount | currency }}
                      <i
                        class="fas fa-arrow-up text-success"
                        style="transform: rotate(45deg)"
                      ></i>
                    </small>
                  </p>
                  <p class="mb-1">
                    <small
                      class="d-flex align-items-center justify-content-between"
                    >
                      {{ (info.amount / info.totalProposals) | currency }}
                      <i
                        class="fas fa-arrow-down text-danger"
                        style="transform: rotate(45deg)"
                      ></i>
                    </small>
                  </p>
                </div>
              </b-card>
            </div>
            <div v-if="selectedButton === 'Fluxo'" class="my-3">
              Nota: Existe {{ totalNewInservice || 0 }} Nova proposta ou Em
              Atendimento.
            </div>
          </b-col>
        </b-row>
        <!-- <div class="d-flex justify-content-between my-5">
          <b-card
            v-for="(info, infoIndex) in setAmountInformation"
            :key="infoIndex"
            class="shadow rounded mx-3 w-50"
          >
            <div class="d-flex flex-column text-muted">
              <span class="d-flex align-items-center justify-content-between">
                <h6 class="lead">
                  {{ info.modality }}
                  <small class="exp">{{ info.totalProposals }}</small>
                </h6>
                <i
                  class="fas fa-arrow-up text-success"
                  style="transform: rotate(45deg)"
                ></i>
              </span>
              <p class="mb-1">
                <small
                  class="d-flex align-items-center justify-content-between"
                >
                  {{ info.amount | currency }}
                  <i
                    class="fas fa-arrow-up text-success"
                    style="transform: rotate(45deg)"
                  ></i>
                </small>
              </p>
              <p class="mb-1">
                <small
                  class="d-flex align-items-center justify-content-between"
                >
                  {{ (info.amount / info.totalProposals) | currency }}
                  <i
                    class="fas fa-arrow-down text-danger"
                    style="transform: rotate(45deg)"
                  ></i>
                </small>
              </p>
            </div>
          </b-card>
        </div> -->

        <!-- <div v-if="details1.length" class="d-flex justify-content-between my-5">
          <b-card
            v-for="(data, index) in details1"
            :key="index"
            class="shadow rounded mx-3 w-50"
          >
            <div class="d-flex flex-column text-muted">
              <span class="d-flex align-items-center justify-content-between">
                <div>
                  <div class="card-name">
                    {{ data.name }}
                  </div>
                  <div v-if="data.name !== 'CONVERSION RATE'">
                    <span class="card-proposal mr-1">{{ data.proposals }}</span>
                    <small>Propostas</small>
                  </div>
                </div>
                <vue-ellipse-progress
                  :progress="data.percentage"
                  color="#247cab"
                  :size="100"
                  :thickness="5"
                  :empty-thickness="5"
                  animation="bounce 700 1000"
                  fontSize="1rem"
                  fontColor="#377dff"
                  dot="12 #185575"
                  empty-color="#c7c7c7"
                >
                  <span slot="legend-value" class="text-primary"> % </span>
                  <template v-slot:legend-caption>
                    <span class="small" slot="legend-caption">do total</span>
                  </template>
                </vue-ellipse-progress>
              </span>
              <small
                class="
                  card-currency
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                {{ data.values | currency }}
              </small>
              <div class="chart-text">
                {{ data.text }}
              </div>
            </div>
          </b-card>
        </div> -->

        <!-- <div v-if="details2.length" class="d-flex justify-content-between my-5">
          <b-card
            v-for="(data, index) in details2"
            :key="index"
            class="shadow rounded mx-3 w-50"
          >
            <div class="d-flex flex-column text-muted">
              <span class="d-flex align-items-center justify-content-between">
                <div>
                  <div class="card-name">
                    {{ data.name }}
                  </div>
                  <div v-if="data.name !== 'CONVERSION RATE'">
                    <span class="card-proposal mr-1">{{ data.proposals }}</span>
                    <small>Propostas</small>
                  </div>
                </div>
                <vue-ellipse-progress
                  :progress="data.percentage"
                  color="#247cab"
                  :size="100"
                  :thickness="5"
                  :empty-thickness="5"
                  animation="bounce 700 1000"
                  fontSize="1rem"
                  fontColor="#377dff"
                  dot="12 #185575"
                  empty-color="#c7c7c7"
                >
                  <span slot="legend-value" class="text-primary"> % </span>
                  <template v-slot:legend-caption>
                    <span class="small" slot="legend-caption">do total</span>
                  </template>
                </vue-ellipse-progress>
              </span>
              <div
                class="
                  card-currency
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                {{ data.values | currency }}
              </div>
              <div class="chart-text">
                {{ data.text }}
              </div>
            </div>
          </b-card>
        </div> -->

        <b-row>
          <b-col lg="12">
            <b-card class="shadow rounded mb-4">
              <h6 class="lead text-muted">Fluxo Potencial Agência</h6>

              <DashboardBankBranchListTable
                :selectedButton="selectedButton"
                :proposals="filteredProposals"
                :allProposals="allProposals"
                :selectedBranch="selectedBranch"
                @getSelectedBranches="getSelectedBranches"
              />
              <small class="float-right text-muted"
                ><i>Carregar mais...</i></small
              >
            </b-card>
          </b-col>
          <b-col lg="8">
            <b-card class="shadow rounded mb-3">
              <h6 class="lead text-muted">Fluxo Potencial Consultor</h6>
              <b-table
                id="table-transition-example"
                :items="filteredProposals"
                :fields="fields"
                select-mode="single"
                @row-selected="onRowSelected"
                selectable
                striped
                small
                primary-key="Agência"
                :tbody-transition-props="transProps"
              >
                <template v-slot:cell(#)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
              </b-table>
              <small class="float-right text-muted"
                ><i>Carregar mais...</i></small
              >
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card class="shadow rounded mb-3">
              <h6 class="lead text-muted float-left">Quadro Realize</h6>
              <b-button v-b-toggle.collapse-2 class="m-1 float-right"
                >Toggle</b-button
              >
              <b-collapse class="lg-12" id="collapse-2">
                <b-table striped hover :items="result"></b-table>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <b-card
        v-for="(data, index) in proposalsByBranch"
        :key="index"
        class="mb-4"
      >
        <b-card-sub-title class="mb-3">{{ data.branch }}</b-card-sub-title>
        <branchProposalsTable
          :proposals="data.proposals"
          :selectedButton="selectedButton"
        />
      </b-card>
    </b-card>
    <b-row class="position-relative" style="top: -50px">
      <b-col class="d-flex align-items-center justify-content-around">
        <!-- <b-card
          v-for="test in informationTest"
          :key="test"
          class="shadow rounded mx-3 w-50"
        >
          <div class="d-flex flex-column text-muted">
            <span class="d-flex align-items-center justify-content-between">
              <h6 class="lead">
                {{ test.modality }}
                <small>{{ test.totalProposals }}</small>
              </h6>
              <i
                class="fas fa-arrow-up text-success"
                style="transform: rotate(45deg);"
              ></i>
            </span>
            <p class="mb-1">
              <small class="d-flex align-items-center justify-content-between">
                R$ {{ test.amount }}
                <i
                  class="fas fa-arrow-up text-success"
                  style="transform: rotate(45deg);"
                ></i>
              </small>
            </p>
            <p class="mb-1">
              <small class="d-flex alig
              
              n-items-center justify-content-between">
                R$ {{ test.averageTicket }}
                <i
                  class="fas fa-arrow-down text-danger"
                  style="transform: rotate(45deg);"
                ></i>
              </small>
            </p>
          </div>
        </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VueApexCharts from "vue-apexcharts";
import DashboardBankBranchListTable from "@/components/Tables/dashboardBankBranchListTable.vue";
import branchProposalsTable from "@/components/Tables/branchProposalsTable.vue";

import VueHtml2pdf from "vue-html2pdf";
import Chart from "@/components/Charts/Chart.vue";
var moment = require("moment");
moment.locale("pt");
export default {
  components: {
    apexchart: VueApexCharts,
    DashboardBankBranchListTable,
    VueHtml2pdf,
    Chart,
    branchProposalsTable,
  },
  name: "Dashboard",
  data() {
    return {
      filterPeriod: {
        start: "",
        end: "",
      },
      selectedButton: "",
      selected: [],
      amountInformation: [
        {
          modality: "SBPE",
          averageTicket: 750000.0,
        },
        {
          modality: "CCFGTS",
          averageTicket: 150000.0,
        },
        {
          modality: "PMCMV",
          averageTicket: 125000.0,
        },
        {
          modality: "PRÓ COT",
          averageTicket: 0.0,
        },
        {
          modality: "CRF",
          averageTicket: 0.0,
        },
      ],
      options: [
        { value: "daily", text: "Daily" },
        { value: "weekly", text: "Weekly" },
        { value: "monthly", text: "Monthly" },
        { value: "yearly", text: "Yearly" },
        { value: "customize", text: "Customize" },
      ],
      filterArr: ["Estoque", "Fluxo", "Resultado"],
      transProps: {
        // Transition name
        name: "flip-list",
      },
      items: [
        {
          Agência: "Nilóplis",
          Qnt: 1,
          EstoqueFluxoOuResultado: "R$ 100.000,00",
          TicketMédio: "R$ 1.000,00",
          txc: "10%",
        },
        {
          Agência: "Anil",
          Qnt: 5,
          EstoqueFluxoOuResultado: "R$ 120.000,00",
          TicketMédio: "R$ 1.200,00",
          txc: "10%",
        },
        {
          Agência: "Shopping Grande Rio",
          Qnt: 8,
          EstoqueFluxoOuResultado: "R$ 300.000,00",
          TicketMédio: "R$ 3.000,00",
          txc: "10%",
        },
        {
          Agência: "Tindiba",
          Qnt: 2,
          EstoqueFluxoOuResultado: "R$ 400.000,00",
          TicketMédio: "R$ 4.000,00",
          txc: "10%",
        },
      ],
      fields: [
        { key: "#", sortable: false },
        { key: "Agência", sortable: true },
        { key: "Qnt", sortable: true },
        { key: "Amount", sortable: true },
        { key: "TicketMédio", sortable: true },
        { key: "Txc", sortable: true },
      ],
      result: [
        { Previsão: "R$ 1.000.000,00", Realizado: "R$ 500.000,00" },
        { Previsão: "R$ 10.000,00", Realizado: "R$ 5.000,00" },
      ],
      selectedBranch: [],
      chartData: [],
      isLoading: false,
      detailsData: [],
      // showDetails: false,
      details1: [],
      condicionadoProposals: [],
      pendingInactive: [],
      inactiveApproved: [],
      approvedCardArr: [],
      pendingCardArr: [],
      failedCardArr: [],
      inProgressCardArr: [],
      contractorCardArr: [],
      inactiveCardArr: []
    };
  },
  computed: {
    ...mapState([
      "filteredProposals",
      "allProposals",
      "approvedArr",
      "contractedArr",
      "failedArr",
      "pendingArr",
      "progressArr",
      "inactiveArr",
      "newProposalsLength",
      "newChartProposalsLength",
      "inServiceProposalsLength",
    ]),
    proposals() {
      if (this.selectedBranch && this.selectedBranch.length) {
        return this.filteredProposals.filter((el) =>
          this.selectedBranch.includes(el.bankBranch)
        );
      } else {
        return this.filteredProposals;
      }
    },
    totalAmount() {
      let value = 0;
      this.proposals.forEach((element) => {
        if (this.selectedButton === "Estoque") {
          if (element.approvedFinancingAmount) {
            value = value + element.approvedFinancingAmount;
          }
        } else if (this.selectedButton === "Resultado") {
          if (element.operationValue) {
            value = value + element.operationValue;
          }
        } else if (this.selectedButton === "Fluxo") {
          if (element.intendedFinancingValue) {
            value = value + element.intendedFinancingValue;
          }
        }
      });
      return value;
    },
    sbpeProposals() {
      if (this.proposals && this.proposals.length) {
        return this.proposals.filter((el) => el.operationModality === "SBPE");
      }
      return [];
    },
    sbpeAmount() {
      if (this.sbpeProposals && this.sbpeProposals.length) {
        return this.getAmount(this.sbpeProposals);
      } else {
        return 0;
      }
    },
    ccfgtsProposals() {
      if (this.proposals && this.proposals.length) {
        return this.proposals.filter((el) => el.operationModality === "CCFGTS");
      }
      return [];
    },
    ccfgtsAmount() {
      if (this.ccfgtsProposals && this.ccfgtsProposals.length) {
        return this.getAmount(this.ccfgtsProposals);
      } else {
        return 0;
      }
    },
    pmcmvProposals() {
      if (this.proposals && this.proposals.length) {
        return this.proposals.filter((el) => el.operationModality === "PMCMV");
      } else {
        return [];
      }
    },
    pmcmvAmount() {
      if (this.pmcmvProposals && this.pmcmvProposals.length) {
        return this.getAmount(this.pmcmvProposals);
      } else {
        return 0;
      }
    },
    cotistaProposals() {
      if (this.proposals && this.proposals.length) {
        return this.proposals.filter(
          (el) => el.operationModality === "PRÓ COTISTA"
        );
      } else {
        return [];
      }
    },
    cotistaAmount() {
      if (this.cotistaProposals && this.cotistaProposals.length) {
        return this.getAmount(this.cotistaProposals);
      } else {
        return 0;
      }
    },
    crfProposals() {
      if (this.proposals && this.proposals.length) {
        return this.proposals.filter((el) => el.operationModality === "CRF");
      } else {
        return [];
      }
    },
    crfAmount() {
      if (this.crfProposals && this.crfProposals.length) {
        return this.getAmount(this.crfProposals);
      } else {
        return 0;
      }
    },
    setAmountInformation() {
      this.amountInformation.forEach((element) => {
        if (element.modality === "SBPE") {
          element.amount = this.sbpeAmount;
          element.totalProposals = this.sbpeProposals.length;
        } else if (element.modality === "CCFGTS") {
          element.amount = this.ccfgtsAmount;
          element.totalProposals = this.ccfgtsProposals.length;
        } else if (element.modality === "PMCMV") {
          element.amount = this.pmcmvAmount;
          element.totalProposals = this.pmcmvProposals.length;
        } else if (element.modality === "PRÓ COTISTA") {
          element.amount = this.cotistaAmount;
          element.totalProposals = this.cotistaProposals.length;
        } else if (element.modality === "CRF") {
          element.amount = this.crfAmount;
          element.totalProposals = this.crfProposals.length;
        }
      });

      return this.amountInformation;
    },
    proposalsByBranch() {
      let arr = [];
      this.proposals.forEach((element) => {
        let obj = {};
        obj.branch = element.bankBranch;
        const filteredByBranch = this.proposals.filter(
          (el) => el.bankBranch === element.bankBranch
        );
        obj.proposals = filteredByBranch;
        if (arr.length) {
          if (!arr.some((el) => el.branch === element.bankBranch)) {
            arr.push(obj);
          }
        } else {
          arr.push(obj);
        }
      });

      return arr;
    },
    totalNewInservice() {
      return this.inServiceProposalsLength + this.newChartProposalsLength;
    },
    condicionadoAmount() {
      const addProperties = this.condicionadoProposals.reduce((acc, n) => {
        if (acc.hasOwnProperty("approvedFinancingAmount"))
          acc["approvedFinancingAmount"] += n["approvedFinancingAmount"];
        else acc["approvedFinancingAmount"] = n["approvedFinancingAmount"];
        return acc;
      }, {});
      return addProperties.approvedFinancingAmount
        ? addProperties.approvedFinancingAmount.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : 0;
    },
    pendingInactiveAmount() {
      const addProperties = this.pendingInactive.reduce((acc, n) => {
        if (acc.hasOwnProperty("intendedFinancingValue"))
          acc["intendedFinancingValue"] += n["intendedFinancingValue"];
        else acc["intendedFinancingValue"] = n["intendedFinancingValue"];
        return acc;
      }, {});
      return addProperties.intendedFinancingValue
        ? addProperties.intendedFinancingValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "R$ 0";
    },
    inactiveApprovedAmount() {
      const addProperties = this.inactiveApproved.reduce((acc, n) => {
        if (acc.hasOwnProperty("approvedFinancingAmount"))
          acc["approvedFinancingAmount"] += n["approvedFinancingAmount"];
        else acc["approvedFinancingAmount"] = n["approvedFinancingAmount"];
        return acc;
      }, {});
      return addProperties.approvedFinancingAmount
        ? addProperties.approvedFinancingAmount.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "R$ 0";
    },
  },
  watch: {
    async selectedButton(newVal) {
      this.selectedBranch = [];
      await this.getProposalsDataForCalculation({
        filterBy: newVal,
        period: this.filterPeriod,
      });
      this.calculateData();
      this.getChartInserviceProposals(this.filterPeriod);
      this.getChartNewProposals(this.filterPeriod);
    },
    async filterPeriod(newVal) {
      await this.getProposalsDataForCalculation({
        filterBy: this.selectedButton,
        period: newVal,
      });
      this.getChartInserviceProposals(this.filterPeriod);
      this.getChartNewProposals(this.filterPeriod);
      this.calculateData();
    },
  },
  async mounted() {
    this.selectedButton = "Estoque";
    this.filterPeriod = {
      start: moment().startOf("day"),
      end: moment().endOf("day"),
    };
    this.getAllproposals();
  },
  methods: {
    ...mapActions([
      "getProposalsDataForCalculation",
      "getAllproposals",
      "getChartInserviceProposals",
      "getChartNewProposals",
    ]),
    onRowSelected(items) {
      console.log(items, "444444444444444444444444444");
    },
    calculateData() {
      let arr = [];
      let arr2 = [];
      this.chartData = [];
      this.approvedCardArr = [],
      this.pendingCardArr = [],
      this.failedCardArr = [],
      this.inProgressCardArr = [],
      this.contractorCardArr = [];
      this.inactiveCardArr = [];
      let intendedFinancingValue = 0;
      let approvedFinancingAmount = 0;
      let approvedIntendedFinancingValue = 0;
      let contractedIntendedFinancingValue = 0;
      let failedIntendedFinancingValue = 0;
      let pendingIntendedFinancingValue = 0;
      let progressIntendedFinancingValue = 0;
      let inactiveIntendedFinancingValue = 0;
      if (this.selectedButton === "Estoque") {
        this.details1 = [];
        const activedProposals = this.proposals.filter((el) => el.actived)
        for (let index = 0; index < this.proposals.length; index++) {
          let smallArr1 = [];
          let date1;
          let smallArr2 = [];
          let date2;
          date1 = new Date(this.proposals[index].created.toDate()).getTime();
          smallArr1.push(date1);
          smallArr1.push(this.proposals[index].approvedFinancingAmount);
          arr.push(smallArr1);

          approvedFinancingAmount =
            approvedFinancingAmount +
            this.proposals[index].approvedFinancingAmount;
          date2 = new Date(this.proposals[index].created.toDate()).getTime();
          smallArr2.push(date2);
          smallArr2.push(approvedFinancingAmount);
          arr2.push(smallArr2);
        }

        const filteredApproved = activedProposals.filter((el) =>
          this.approvedArr.find((elm) => elm.cpf === el.cpf)
        );
        console.log(filteredApproved, 'filteredApproved>>>', activedProposals, 'this.approvedArr', this.approvedArr);
        for (let index = 0; index < filteredApproved.length; index++) {
          let smallArr3 = [];
          let date3;
          approvedIntendedFinancingValue =
            approvedIntendedFinancingValue +
            filteredApproved[index].approvedFinancingAmount;
          date3 = new Date(filteredApproved[index].created.toDate()).getTime();
          smallArr3.push(date3);
          smallArr3.push(approvedIntendedFinancingValue);
          // arr3.push(smallArr3);
          this.approvedCardArr.push(smallArr3);
        }


        this.inactiveApproved = filteredApproved.filter((el) => !el.actived);

        this.condicionadoProposals = activedProposals.filter(
          (el) =>
            el.steps.riskAssessment.status === "Condicionado" &&
            !el.steps.engineering.actived
        );



        const filteredPending = activedProposals.filter((el) =>
          this.pendingArr.find((elm) => elm.cpf === el.cpf)
        );

        this.pendingInactive = filteredPending.filter((el) => !el.actived);

        for (let index = 0; index < filteredPending.length; index++) {
          let smallArr6 = [];
          let date6;
          pendingIntendedFinancingValue =
            pendingIntendedFinancingValue +
            filteredPending[index].intendedFinancingValue;
          date6 = new Date(filteredPending[index].created.toDate()).getTime();
          smallArr6.push(date6);
          smallArr6.push(pendingIntendedFinancingValue);
          // arr6.push(smallArr6);
          this.pendingCardArr.push(smallArr6);
        }


        const filteredInactive = activedProposals.filter((el) =>
          this.inactiveArr.find((elm) => elm.cpf === el.cpf)
        );
        for (let index = 0; index < filteredInactive.length; index++) {
          let smallArr8 = [];
          let date8;
          inactiveIntendedFinancingValue =
            inactiveIntendedFinancingValue +
            filteredInactive[index].intendedFinancingValue;
          date8 = new Date(filteredInactive[index].created.toDate()).getTime();
          smallArr8.push(date8);
          smallArr8.push(inactiveIntendedFinancingValue);
          // arr8.push(smallArr8);
          this.inactiveCardArr.push(smallArr8);
        }

        this.details1 = [
          {
            name: "Aprovadas", // Approved
            proposals: this.approvedCardArr.length,
            values: this.approvedCardArr.length ? this.approvedCardArr[this.approvedCardArr.length - 1][1] : 0,
            percentage:
              this.approvedCardArr.length / this.proposals.length
                ? ((this.approvedCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `${this.condicionadoProposals.length} Proposta(s) Condicionada(s) ${this.condicionadoAmount}`,
          },
          {
            name: "Com pendência(s)", // PENDING
            proposals: this.pendingCardArr.length,
            values: this.pendingCardArr.length ? this.pendingCardArr[this.pendingCardArr.length - 1][1] : 0,
            percentage:
              this.pendingCardArr.length / this.proposals.length
                ? ((this.pendingCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `${this.pendingInactive.length} Propostas perdidas (Inativas) ${this.pendingInactiveAmount}`,
          },
          {
            name: "Inativa (Perdas)", // INACTIVE
            proposals: this.inactiveCardArr.length,
            values: this.inactiveCardArr.length ? this.inactiveCardArr[this.inactiveCardArr.length - 1][1] : 0,
            percentage:
              this.inactiveCardArr.length / this.proposals.length
                ? ((this.inactiveCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `${this.inactiveApproved.length} Propostas Aprovadas ${this.inactiveApprovedAmount}`,
          },
        ];

        this.chartData = [
          {
            name: "Valor da Proposta Aprovada Individual",
            data: arr,
          },
          {
            name: ": Valor Acumulado das Propostas Aprovadas",
            data: arr2,
          },
        ];
      } else if (this.selectedButton === "Fluxo") {
        // let arr3 = [];
        // let arr4 = [];
        // let arr5 = [];
        // let arr6 = [];
        // let arr7 = [];

        for (let index = 0; index < this.proposals.length; index++) {
          let smallArr1 = [];
          let date1;
          let smallArr2 = [];
          let date2;
          date1 = new Date(this.proposals[index].created.toDate()).getTime();
          smallArr1.push(date1);
          smallArr1.push(this.proposals[index].intendedFinancingValue);
          arr.push(smallArr1);

          intendedFinancingValue =
            intendedFinancingValue +
            this.proposals[index].intendedFinancingValue;
          date2 = new Date(this.proposals[index].created.toDate()).getTime();
          smallArr2.push(date2);
          smallArr2.push(intendedFinancingValue);
          arr2.push(smallArr2);
        }

        const filteredApproved = this.proposals.filter((el) =>
          this.approvedArr.find((elm) => elm.cpf === el.cpf)
        );
        for (let index = 0; index < filteredApproved.length; index++) {
          let smallArr3 = [];
          let date3;
          approvedIntendedFinancingValue =
            approvedIntendedFinancingValue +
            filteredApproved[index].approvedFinancingAmount;
          date3 = new Date(filteredApproved[index].created.toDate()).getTime();
          smallArr3.push(date3);
          smallArr3.push(approvedIntendedFinancingValue);
          // arr3.push(smallArr3);
          this.approvedCardArr.push(smallArr3);
        }

        this.inactiveApproved = filteredApproved.filter((el) => !el.actived);

        this.condicionadoProposals = this.proposals.filter(
          (el) =>
            el.steps.riskAssessment.status === "Condicionado" &&
            !el.steps.engineering.actived
        );

        const filteredContracted = this.proposals.filter((el) =>
          this.contractedArr.find((elm) => elm.cpf === el.cpf)
        );
        for (let index = 0; index < filteredContracted.length; index++) {
          let smallArr4 = [];
          let date4;
          contractedIntendedFinancingValue =
            contractedIntendedFinancingValue +
            filteredContracted[index].intendedFinancingValue;
          date4 = new Date(
            filteredContracted[index].created.toDate()
          ).getTime();
          smallArr4.push(date4);
          smallArr4.push(contractedIntendedFinancingValue);
          // arr4.push(smallArr4);
          this.contractorCardArr.push(smallArr4);
        }

        const filteredFailed = this.proposals.filter((el) =>
          this.failedArr.find((elm) => elm.cpf === el.cpf)
        );
        for (let index = 0; index < filteredFailed.length; index++) {
          let smallArr5 = [];
          let date5;
          failedIntendedFinancingValue =
            failedIntendedFinancingValue +
            filteredFailed[index].intendedFinancingValue;
          date5 = new Date(filteredFailed[index].created.toDate()).getTime();
          smallArr5.push(date5);
          smallArr5.push(failedIntendedFinancingValue);
          // arr5.push(smallArr5);
          this.failedCardArr.push(smallArr5);
        }

        const filteredPending = this.proposals.filter((el) =>
          this.pendingArr.find((elm) => elm.cpf === el.cpf)
        );

        this.pendingInactive = filteredPending.filter((el) => !el.actived);

        for (let index = 0; index < filteredPending.length; index++) {
          let smallArr6 = [];
          let date6;
          pendingIntendedFinancingValue =
            pendingIntendedFinancingValue +
            filteredPending[index].intendedFinancingValue;
          date6 = new Date(filteredPending[index].created.toDate()).getTime();
          smallArr6.push(date6);
          smallArr6.push(pendingIntendedFinancingValue);
          // arr6.push(smallArr6);
          this.pendingCardArr.push(smallArr6);
        }

        const filteredProgress = this.proposals.filter((el) =>
          this.progressArr.find((elm) => elm.cpf === el.cpf)
        );
        for (let index = 0; index < filteredProgress.length; index++) {
          let smallArr7 = [];
          let date7;
          progressIntendedFinancingValue =
            progressIntendedFinancingValue +
            filteredProgress[index].intendedFinancingValue;
          date7 = new Date(filteredProgress[index].created.toDate()).getTime();
          smallArr7.push(date7);
          smallArr7.push(progressIntendedFinancingValue);
          // arr7.push(smallArr7);
          this.inProgressCardArr.push(smallArr7);
        }

        const filteredInactive = this.proposals.filter((el) =>
          this.inactiveArr.find((elm) => elm.cpf === el.cpf)
        );
        for (let index = 0; index < filteredInactive.length; index++) {
          let smallArr8 = [];
          let date8;
          inactiveIntendedFinancingValue =
            inactiveIntendedFinancingValue +
            filteredInactive[index].intendedFinancingValue;
          date8 = new Date(filteredInactive[index].created.toDate()).getTime();
          smallArr8.push(date8);
          smallArr8.push(inactiveIntendedFinancingValue);
          // arr8.push(smallArr8);
          this.inactiveCardArr.push(smallArr8);
        }

                 this.details1 = [
          {
            name: "Aprovadas", // Approved
            proposals: this.approvedCardArr.length,
            values: this.approvedCardArr.length ? this.approvedCardArr[this.approvedCardArr.length - 1][1] : 0,
            percentage:
              this.approvedCardArr.length / this.proposals.length
                ? ((this.approvedCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `${this.condicionadoProposals.length} Proposta(s) Condicionada(s) ${this.condicionadoAmount}`,
          },
          {
            name: "Com pendência(s)", // PENDING
            proposals: this.pendingCardArr.length,
            values: this.pendingCardArr.length ? this.pendingCardArr[this.pendingCardArr.length - 1][1] : 0,
            percentage:
              this.pendingCardArr.length / this.proposals.length
                ? ((this.pendingCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `${this.pendingInactive.length} Propostas perdidas (Inativas) ${this.pendingInactiveAmount}`,
          },
          {
            name: "Reprovadas", // FAILED
            proposals: this.failedCardArr.length,
            values: this.failedCardArr.length ? this.failedCardArr[this.failedCardArr.length - 1][1] : 0,
            percentage:
              this.failedCardArr.length / this.proposals.length
                ? ((this.failedCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
          },
          {
            name: "Em andamento", // progress
            proposals: this.inProgressCardArr.length,
            values: this.inProgressCardArr.length ? this.inProgressCardArr[this.inProgressCardArr.length - 1][1] : 0,
            percentage:
              this.inProgressCardArr.length / this.proposals.length
                ? ((this.inProgressCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `Taxa de conversão de ${
              this.inProgressCardArr.length / this.approvedCardArr.length
                ? ((this.inProgressCardArr.length / this.approvedCardArr.length) * 100).toFixed(2)
                : 0
            }% das Aprovadas`,
          },
          {
            name: "Contratadas", // Contracted
            proposals: this.contractorCardArr.length,
            values: this.contractorCardArr.length ? this.contractorCardArr[this.contractorCardArr.length - 1][1] : 0,
            percentage:
              this.contractorCardArr.length / this.proposals.length
                ? ((this.contractorCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `Taxa de conversão de ${
              this.contractorCardArr.length / this.approvedCardArr.length
                ? ((this.contractorCardArr.length / this.approvedCardArr.length) * 100).toFixed(2)
                : 0
            }% das Aprovadas`,
          },
          {
            name: "Inativa (Perdas)", // INACTIVE
            proposals: this.inactiveCardArr.length,
            values: this.inactiveCardArr.length ? this.inactiveCardArr[this.inactiveCardArr.length - 1][1] : 0,
            percentage:
              this.inactiveCardArr.length / this.proposals.length
                ? ((this.inactiveCardArr.length / this.proposals.length) * 100).toFixed(2)
                : 0,
            text: `${this.inactiveApproved.length} Propostas Aprovadas ${this.inactiveApprovedAmount}`,
          },
        ];

        // this.details1 = [
        //   {
        //     name: "Aprovadas", // Approved
        //     proposals: arr3.length,
        //     values: arr3.length ? arr3[arr3.length - 1][1] : 0,
        //     percentage:
        //       arr3.length / this.proposals.length
        //         ? ((arr3.length / this.proposals.length) * 100).toFixed(2)
        //         : 0,
        //     text: `${this.condicionadoProposals.length} Proposta(s) Condicionada(s) ${this.condicionadoAmount}`,
        //   },
        //   {
        //     name: "Com pendência(s)", // PENDING
        //     proposals: arr6.length,
        //     values: arr6.length ? arr6[arr6.length - 1][1] : 0,
        //     percentage:
        //       arr6.length / this.proposals.length
        //         ? ((arr6.length / this.proposals.length) * 100).toFixed(2)
        //         : 0,
        //     text: `${this.pendingInactive.length} Propostas perdidas (Inativas) ${this.pendingInactiveAmount}`,
        //   },
        //   {
        //     name: "Reprovadas", // FAILED
        //     proposals: arr5.length,
        //     values: arr5.length ? arr5[arr5.length - 1][1] : 0,
        //     percentage:
        //       arr5.length / this.proposals.length
        //         ? ((arr5.length / this.proposals.length) * 100).toFixed(2)
        //         : 0,
        //   },
        //   {
        //     name: "Em andamento", // progress
        //     proposals: arr7.length,
        //     values: arr7.length ? arr7[arr7.length - 1][1] : 0,
        //     percentage:
        //       arr7.length / this.proposals.length
        //         ? ((arr7.length / this.proposals.length) * 100).toFixed(2)
        //         : 0,
        //     text: `Taxa de conversão de ${
        //       arr7.length / arr3.length
        //         ? ((arr7.length / arr3.length) * 100).toFixed(2)
        //         : 0
        //     }% das Aprovadas`,
        //   },
        //   {
        //     name: "Contratadas", // Contracted
        //     proposals: arr4.length,
        //     values: arr4.length ? arr4[arr4.length - 1][1] : 0,
        //     percentage:
        //       arr4.length / this.proposals.length
        //         ? ((arr4.length / this.proposals.length) * 100).toFixed(2)
        //         : 0,
        //     text: `Taxa de conversão de ${
        //       arr4.length / arr3.length
        //         ? ((arr4.length / arr3.length) * 100).toFixed(2)
        //         : 0
        //     }% das Aprovadas`,
        //   },
        //   {
        //     name: "Inativa (Perdas)", // INACTIVE
        //     proposals: arr8.length,
        //     values: arr8.length ? arr8[arr8.length - 1][1] : 0,
        //     percentage:
        //       arr8.length / this.proposals.length
        //         ? ((arr8.length / this.proposals.length) * 100).toFixed(2)
        //         : 0,
        //     text: `${this.inactiveApproved.length} Propostas Aprovadas ${this.inactiveApprovedAmount}`,
        //   },
        // ];

        this.chartData = [
          {
            name: "Valor individual das novas Propostas",
            data: arr,
          },
          {
            name: "Valor Acumulado das novas Propostas",
            data: arr2,
          },
          {
            name: "approved",
            data: this.approvedCardArr,
          },
          {
            name: "contracted",
            data: this.contractorCardArr,
          },
          {
            name: "failed",
            data: this.failedCardArr,
          },
          {
            name: "pending",
            data: this.pendingCardArr,
          },
          {
            name: "progress",
            data: this.inProgressCardArr,
          },
        ];
      } else if (this.selectedButton === "Resultado") {
        this.details1 = [];
        const sortedbyCreated = this.proposals.sort(function (x, y) {
          return (
            new Date(x.steps.contract.dueDate) -
            new Date(y.steps.contract.dueDate)
          );
        });

        let holder = {};
        sortedbyCreated.forEach(function (d) {
          if (holder.hasOwnProperty(d.steps.contract.dueDate)) {
            holder[d.steps.contract.dueDate] =
              holder[d.steps.contract.dueDate] + d.operationValue;
          } else {
            holder[d.steps.contract.dueDate] = d.operationValue;
          }
        });

        let newArr = [];
        for (let prop in holder) {
          newArr.push({ contractedDueDate: prop, value: holder[prop] });
        }

        let operationValue = 0;
        for (let index = 0; index < newArr.length; index++) {
          let smallArr1 = [];
          let date1;
          let smallArr2 = [];
          let date2;
          date1 = moment(newArr[index].contractedDueDate).format("X") * 1000;
          smallArr1.push(date1);
          smallArr1.push(newArr[index].value);
          arr.push(smallArr1);

          operationValue = operationValue + newArr[index].value;
          date2 = moment(newArr[index].contractedDueDate).format("X") * 1000;
          smallArr2.push(date2);
          smallArr2.push(operationValue);
          arr2.push(smallArr2);
        }
        this.chartData = [
          {
            name: "Valor da Proposta Contratada Individual",
            data: arr,
          },
          {
            name: "Valor Acumulado das Propostas Contratadas",
            data: arr2,
          },
        ];
      }
    },
    getAmount(arr) {
      const addProperties = arr.reduce((acc, n) => {
        if (acc.hasOwnProperty("approvedFinancingAmount"))
          acc["approvedFinancingAmount"] += n["approvedFinancingAmount"];
        else acc["approvedFinancingAmount"] = n["approvedFinancingAmount"];
        if (acc.hasOwnProperty("operationValue"))
          acc["operationValue"] += n["operationValue"];
        else acc["operationValue"] = n["operationValue"];
        if (acc.hasOwnProperty("intendedFinancingValue"))
          acc["intendedFinancingValue"] += n["intendedFinancingValue"];
        else acc["intendedFinancingValue"] = n["intendedFinancingValue"];
        return acc;
      }, {});

      if (this.selectedButton === "Estoque") {
        return addProperties.approvedFinancingAmount;
      } else if (this.selectedButton === "Fluxo") {
        return addProperties.intendedFinancingValue;
      } else if (this.selectedButton === "Resultado") {
        return addProperties.operationValue;
      }
    },
    getSelectedBranches(val) {
      this.selectedBranch = val;
      this.calculateData();
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    hasStartedGeneration() {
      this.isLoading = true;
    },
    onProgress() {
      this.isLoading = !this.isLoading;
      console.log("2222222222222222222222");
    },
    hasGenerated() {
      console.log("111111111111111111");
    },
  },
};
</script>
<style scoped>
body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  text-align: left;
  /*background-color: #1e1e2f;*/
}
.card {
  border: none;
}
.card-title {
  color: #9a9a9a;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.4em;
}
.card-subtitle {
  color: #1d253b;
  font-weight: 400;
  font-size: 1.6875rem;
  line-height: 1.2;
}
.card h6 small {
  font-size: small;
  position: absolute;
  padding-left: 5px;
}

.card-name {
  color: #9a9a9a;
  font-size: 15px;
  /*font-weight: 600;*/
}
.card-proposal {
  color: #185575;
  font-size: 30px;
  font-weight: 600;
}
.card-currency {
  color: #4d96ff;
  font-size: 30px;
  font-weight: 600;
}
.card .btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7rem;
  line-height: 1;
  border-radius: 0.2rem;
  font-weight: 600;
}
i.fas.fa-file-invoice-dollar {
  color: #6c757d;
  padding: 0.5em;
  border-radius: 50%;
}

i.fas.fa-file-invoice-dollar:hover {
  color: #000000;
  padding: 0.5em;
  border-radius: 50%;
  background-color: #e3e7eb;
}
.details-wrapper {
  width: 500px;
  position: absolute;
  z-index: 9;
  background-color: #e3e7eb;
}
::v-deep .ep-svg {
  margin-bottom: 0;
}
.chart-text {
  font-size: 12px;
}
.mini-cards {
  overflow: auto;
  max-width: 100%;
  padding: 5px 0;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  /*background: #8f8f8f;*/
  border: 5px double #e1e1e1;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b1b1b1;
}
::-webkit-scrollbar-thumb:active {
  background: #888888;
}
::-webkit-scrollbar-track {
  /*background: #ffffff;
  border: 10px ridge #ffffff;*/
  border-radius: 10px;
}
::-webkit-scrollbar-track:hover {
  background: #e0e0e0;
}
::-webkit-scrollbar-track:active {
  background: #bababa;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
<style>
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
.ep-legend--container {
   line-height: 1;
}
.ep-legend--value {
  line-height: 1;
}
</style>
